import { render, staticRenderFns } from "./TableFileList.vue?vue&type=template&id=450f53c6&scoped=true&"
import script from "./TableFileList.vue?vue&type=script&lang=ts&"
export * from "./TableFileList.vue?vue&type=script&lang=ts&"
import style0 from "./TableFileList.vue?vue&type=style&index=0&id=450f53c6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "450f53c6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VMenu})
